import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-471bbda4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-text-[red]"
}
const _hoisted_2 = { class: "dropdown" }

import { PropType, computed, ref } from "vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import VRuntimeTemplate from "vue3-runtime-template";


export default /*#__PURE__*/_defineComponent({
  __name: 'wizardDropdown',
  props: {
  id: { type: String, required: true },
  title: { type: String, required: true },
  data: { type: Array as PropType<IDropDownData[]>, required: true },
  placeholder: { type: String, required: false, default: "" },
  classTitle: { type: String, required: false, default: "" },
  required: { type: Boolean, required: false, default: false },
  modelValue: {
    type: String,
    default: () => {
      return null;
    },
  },
  validation: { type: Object, required: false, default: null },
  isApiError: { type: Boolean, required: false, default: false },
  useVisualScroll: { type: Boolean, required: false, default: false },
},
  emits: ["update:modelValue", "update:valueTeamPage"],
  setup(__props, { emit }) {

const props = __props;


const isFocus = ref(false);


const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

const selectValue = (value: IDropDownData) => {
  emit("update:modelValue", value);
  emit("update:valueTeamPage", value);
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_row, {
      class: _normalizeClass('row-container tw-flex tw-flex-row tw-gap-[40px] tw-mr-0 tw-ml-0')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          class: _normalizeClass('tw-pr-0 tw-pl-0 tw-flex tw-items-center')
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", {
              class: _normalizeClass([
            'tw-mb-0 tw-text-[14px] tw-text-[#231F20] tw-leading-[145%] tw-font-medium tw-font-Poppins',
            __props.classTitle,
          ])
            }, _toDisplayString(__props.title), 3),
            (__props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, " *"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-sm-6 tw-pr-0 tw-pl-0')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(BaseDropDown, {
                id: __props.id,
                modelValue: value.value,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
                  _cache[1] || (_cache[1] = (e) => selectValue(e))
                ],
                data: __props.data || [],
                "bg-dropdown": __props.validation?.$errors[0] ? '' : '#eff0f180',
                validation: {},
                "class-name": `gray-dropdown-container-wizard tw-h-[58px] !tw-flex ${
              __props.validation?.$errors[0] ? 'is-invalid-input' : ''
            } ${__props.isApiError ? 'is-api-error' : ''}`,
                placeholder: __props.placeholder,
                "use-visual-scroll": __props.useVisualScroll
              }, null, 8, ["id", "modelValue", "data", "bg-dropdown", "class-name", "placeholder", "use-visual-scroll"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, { class: "align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-container tw-pr-0 tw-pl-0 tw-flex tw-items-center')
        }),
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-sm-6 tw-pr-0 tw-pl-0')
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "feedback", {}, () => [
              (
              !isFocus.value ||
              (isFocus.value && __props.validation?.$errors?.[0]?.$validator === 'required')
            )
                ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                    key: 0,
                    class: _normalizeClass({ 'is-invalid': __props.validation?.$error })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VRuntimeTemplate), {
                        template: __props.validation?.$errors?.[0]?.$message
                      }, null, 8, ["template"])
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ]))
}
}

})